import React from 'react';
import { useFavoriteTournaments, useFavoriteTournamentsDispatch } from './FavoriteTournamentsProvider';
import Img from '../Img';
import { classIf } from '../../data/utils';

export default function FavoriteTournamentButton(props) {
    const favoriteTournaments = useFavoriteTournaments();
    const favoriteTournamentsDispatch = useFavoriteTournamentsDispatch();

    if (favoriteTournaments == null) {
        return null;
    }

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        favoriteTournamentsDispatch({
            type: 'toggle',
            id: props.id
        });
    }

    const active  = favoriteTournaments[props.id] != null;
    const src = active ? 'Favs_active.svg' : 'Favs_default.svg';

    return (
        <Img className={"c_54" + classIf(active, 'active')} src={src} height="16px" width="16px" onClick={handleClick} />
    );
}
